<template>
    <div class="wl-container">
        <div class="wl-content-container">
            <ul class="wl-tab">
                <li :class="active === '1' ? 'active' : ''" @click="handleClick('1')">
                    {{ $t('newsMgt.kccNews') }}
                </li>
                <li :class="active === '3' ? 'active' : ''" @click="handleClick('3')">{{ $t('newsMgt.materials') }}</li>
                <li :class="active === '2' ? 'active' : ''" @click="handleClick('2')">{{ $t('newsMgt.usefulDocument') }}</li>
            </ul>
            <!-- 搜索框 -->
            <div class="wl-search-bar">
                <div class="wl-right">
                    <el-button type="primary" class="wl-green" @click="onEdit({})">{{ $t('COMMON_ADD') }}</el-button>
                    <el-upload
                        class="template-uploader"
                        action="url"
                        :http-request="uploadFiles"
                        :show-file-list="false"
                        :before-upload="beforeAvatarUpload"
                    >
                        <el-button class="wl-green svg-btn"
                            ><img src="@/assets/img/icon-import.svg" width="100%" class="btn-icon" />{{ $t('COMMON_IMPORT') }}</el-button
                        >
                    </el-upload>
                    <el-button type="primary" class="wl-green" @click="publish()">{{ $t('newsMgt.publish') }}</el-button>
                </div>
            </div>

            <!-- 表格 -->
            <div :class="['table-container-wrapper']">
                <el-table height="100%"  v-loading="loading" :data="data" class="wl-user-table" border stripe>
                    <el-table-column
                        type="index"
                        align="center"
                        :label="$t('newsMgt.seq')"
                        width="80"
                        :index="calcIndex"
                    />
                    <el-table-column
                        v-for="(label, index) in labelList"
                        :key="index"
                        :align="label.align || 'center'"
                        :show-overflow-tooltip="label.showOverflowTooltip || false"
                        :label="label.name"
                        :width="label.width ? label.width + 'px' : ''"
                        :min-width="label.minWidth ? label.minWidth + 'px' : ''"
                        :sortable="label.sortable"
                        :prop="label.code"
                        :fixed="label.fixed"
                    >
                        <template slot-scope="scope">
                            <div v-if="label.picture" class="flex justify-center item-center">
                                <img v-if="scope.row[label.code]" :src='`data:image/png;base64,${scope.row[label.code]}`' width="120" height="auto">
                                <el-upload
                                    :ref="scope.row.id"
                                    action
                                    class="wl-icon-upload"
                                    :http-request="(file) => importImage(file,scope.row)"
                                    :show-file-list="false"
                                    :before-upload="beforeImageUpload"
                                    accept="image/png, image/jpeg"
                                >
                                <i class="el-icon-upload"></i>
                                </el-upload>
                            </div>
                            <div v-else-if="label.order">
                                <el-input-number v-model="scope.row[label.code]" controls-position="right" :min="0" v-if="label.order" @change="saveOrUpdate(scope.row)"></el-input-number>
                            </div>
                            <div v-else>
                                {{ scope.row[label.code] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="`${$t('newsMgt.status.1')}?`" prop="status" align="center" width="100">
                        <template slot-scope="scope">
                            <span :style="{color:renderStatusColor(scope.row.status)}">{{ $t(`newsMgt.status.${scope.row.status}`)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :key="9" width="170"  align="center" :label="$t('TABLE_HEADER_Action')">
                        <template slot-scope="scope">
                            <div>
                                <i class="el-icon-edit-outline wl-icon-edit" @click="onEdit(scope.row)"></i>
                                <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" @click="onDelete(scope.row)"></i>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <el-pagination
                class="wl-pagination"
                :current-page="pagination.pageNum"
                :page-size="pagination.pageSize"
                @current-change="onCurrentPageChange"
                @size-change="onSizeChange"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next,sizes,total"
                :total="pagination.total"
            ></el-pagination>

        </div>
        <NewsAdd :active="active" v-if="addVisible" :initData="initData"
          :onCancel="cancelAddVisible" :onAdd="saveOrUpdate"></NewsAdd>
    </div>
</template>
<script>
import API from '@/api'
import { loading } from '@/utils'
import NewsAdd from './components/NewsAdd.vue'

export default {
    name: 'newsManagement',
    data() {
        return {
            active:'1',
            labelObject:{
                '1':[
                    {
                        code:'newsTitle',
                        name:this.$t('newsMgt.newsTitle')
                    },  
                    {
                        code:'newsDesc',
                        name:this.$t('newsMgt.newsDesc')
                    },  
                    {
                        code:'linkText',
                        name:this.$t('newsMgt.linkText')
                    },  
                    {
                        code:'linkUrl',
                        name:this.$t('newsMgt.linkUrl')
                    },  
                    {
                        code:'newsOrder',
                        name:this.$t('newsMgt.newsOrder'),
                        width:160,
                        order:true
                    },  
                    {
                        code:'newsImage',
                        name:this.$t('newsMgt.newsImage'),
                        picture:true
                    },  
                ],
                '2':[
                    {
                        code:'docCategory',
                        name:this.$t('newsMgt.docCategory')
                    },  
                    {
                        code:'docCatalog',
                        name:this.$t('newsMgt.docCatalog')
                    },  
                    {
                        code:'docName',
                        name:this.$t('newsMgt.docName')
                    },  
                    {
                        code:'hyperlink',
                        name:this.$t('newsMgt.hyperlink')
                    },  
                    {
                        code:'docOrder',
                        name:this.$t('newsMgt.docOrder'),
                        width:160,
                        order:true
                    },  
                    
                ],
                '3':[
                    {
                        code:'materialCategory',
                        name:this.$t('newsMgt.materialCategory')
                    },  
                    {
                        code:'materialTitle',
                        name:this.$t('newsMgt.materialTitle')
                    },  
                    
                    {
                        code:'linkUrl',
                        name:this.$t('newsMgt.linkUrl')
                    },  
                    {
                        code:'materialOrder',
                        name:this.$t('newsMgt.materialOrder'),
                        width:160,
                        order:true
                    },  
                    {
                        code:'materialImage',
                        name:this.$t('newsMgt.materialImage'),
                        picture:true
                    },  
                ],
            },
            data: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            initData: {},
            addVisible: false
        }
    },
    computed:{
        labelList() {
            return this.labelObject[this.active]
        },
    },
    mounted() {
        this.queryPageInfo()
    },
    methods: {
        renderStatusColor(status) {
            const statusColorOptions = {
                '1':'#1e49e2',
            }
            return statusColorOptions[status]
        },
        calcIndex(index) {    
            return (this.pagination.pageNum - 1) * this.pagination.pageSize + index+1
        },
        handleClick(tab){
            this.loading = true
            this.active = tab
            this.pagination.pageNum = 1;
            this.pagination.pageSize = 10;
            this.queryPageInfo()
        },
        async queryPageInfo(){
            this.loading = true
            let _api = ''
            switch (this.active) {
                case '1':
                    _api = API.system.queryNewsPageInfo
                    break;
                case '2':
                _api = API.system.queryDocumentsPageInfo
                break;
                case '3':
                _api = API.system.queryMaterialsPageInfo
                break;
            }
            
            try {
                const {code,data} = await _api({
                ...this.pagination
                })
                this.loading = false
                if(code === '1'){
                    this.data = data.records?data.records:[]
                    this.pagination.total = data.total
                }
                
            } catch (error) {
                this.loading = false
            }
            
        },
        async publish(){
            this.$confirm(this.$t('newsMgt.publishTips'),this.$t('newsMgt.publishTitle'),{
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            })
            .then(async () => {
                this.loading = true;
                let _api = ''
                switch (this.active) {
                    case '1':
                    _api = API.system.queryNewsPublish
                    break;
                    case '2':
                    _api = API.system.queryDocumentsPublish
                    break;
                    case '3':
                    _api = API.system.queryMaterialsPublish
                    break;
                }
                try {
                    const res = await _api()
                    this.loading = false
                    if(res.code === '1'){
                        this.$message({
                            type:'success',
                            message: this.$t('msg_success')
                        })
                        this.queryPageInfo()
                    }else{
                        this.$message({
                            type:'error',
                            message: res.errDetails.msg
                        }) 
                    }
                    
                } catch (error) {
                    this.loading = false
                }
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('CANCLE_OPERATION')
                })
            })
        },
        cancelAddVisible() {
          this.initData = {}
          this.addVisible = false
        },
        // 编辑
        onEdit(row) {
            this.initData = row
            this.addVisible = !this.addVisible
        },
        async saveOrUpdate(params){
            this.loading = true
            const isAdd = !params.id
            let _api = ''
            switch (this.active) {
                case '1':
                    _api = isAdd?API.system.saveNewsPageInfo:API.system.updateNewsPageInfo
                    delete params['newsImage']
                    break;
                case '2':
                _api = isAdd?API.system.saveDocumentsPageInfo:API.system.updateDocumentsPageInfo
                break;
                case '3':
                _api = isAdd?API.system.saveMaterialsPageInfo:API.system.updateMaterialsPageInfo
                break;
            }
            
            try {
                const {code,data} = await _api(params)
                this.cancelAddVisible()
                this.loading = false
                if(code === '1'){
                    this.queryPageInfo()
                }else {
                this.$message.error(this.$t(code))
            }
                
            } catch (error) {
                this.loading = false
            }
            
        },
        uploadFiles(item) {
            this.fileParams = new FormData()
            this.fileParams.append('file', item.file)
            this.upload()
        },
        async upload() {
            let service = loading()
            const _this = this
            try {
                service.upload()
                let _api = ''
                switch (this.active) {
                    case '1':
                        _api = API.system.newsImportFile
                        break;
                    case '2':
                    _api = API.system.documentsImportFile
                    break;
                    case '3':
                    _api = API.system.materialsImportFile
                    break;
                }
                const response = await _api(this.fileParams)
                if (response) {
                    const { code, data, errDetails } = response
                    if (code === '1') {
                        this.queryPageInfo()
                        
                    } else {
                        this.$message.error(errDetails.msg)
                    }
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        beforeAvatarUpload(file) {
            const isExcel =
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const isLt100K = file.size / 1024 < 100

            if (!isExcel) {
                this.$message.error(this.$t('import_file_type_error'))
            }
            if (!isLt100K) {
                this.$message.error(this.$t('import_tpl_size_100k_error'))
            }
            return isExcel && isLt100K
        },
        beforeImageUpload(file){
            const isImg = ['image/png','image/jpg','image/jpeg'].includes(file.type)
            if(!isImg){
                this.$message.error(this.$t('import_img_type_error'))
            }
            const isLt100K = file.size / 1024 < 100
            if(!isLt100K){
                this.$message.error(this.$t('import_file_size_100k_error'))
            }
            return isImg && isLt100K
        },
        async importImage(item,row){
            const formData = new FormData()
            formData.append('id',row.id)
            formData.append('file',item.file)
            const _api = this.active === '1'?API.system.newsImportImg:API.system.materialsImportImage
            try {
                const {code,data} = await _api(formData);
                if(code === '1'){
                    this.$refs[row.id][0].clearFiles()
                    this.queryPageInfo()
                }
                
            } catch (error) {
                this.$refs[row.id][0].clearFiles()
            }
            
            
        },
        onSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.queryPageInfo()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.queryPageInfo()
        },
        // 删除
        onDelete(row) {
            this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            })
                .then(() => {
                    let _api = ''
                    switch (this.active) {
                        case '1':
                            _api = API.system.deleteKccNew
                            break;
                        case '2':
                        _api = API.system.deleteKccUsefulDocument
                        break;
                        case '3':
                        _api = API.system.deleteKccTrainingMaterial
                        break;
                    }
                    _api({id:row.id}).then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                        } else {
                            this.$message.error(this.$t(code))
                        }
                        this.queryPageInfo()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('CANCLE_OPERATION')
                    })
                })
        },
    },
    components: {
        NewsAdd
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
}
.wl-icon-upload .el-icon-upload{
    font-size: 32px;
    color: #3879eb;
    cursor: pointer;
    margin: 0 0 0 10px;
}

.wl-search-bar {
    font-size: 12px;
    color: #333333;
    margin-bottom: 10px;
}
.search-collapse {
    height: 39px;
    transition: height 0.3s;
    font-size: 12px;
    overflow: hidden;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
}
.search-collapse > div:nth-child(1) {
    margin: 5px 0;
}
.search-collapse.show-search-params {
    height: calc(90px + 65px);
}
.wl-tab {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 38PX;
}
.wl-tab li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14PX;
    padding: 0 30px;
    cursor: pointer;
}
.wl-tab li.active {
    background-color: #3879eb;
}
.wl-left,
.wl-right {
    margin-top: 5px;
    display: flex;
    justify-content: flex-end;
    justify-items: center;
}

.masterCode-sel-cls {
    margin-right: 15px;
    width: 220px;
    margin-bottom: 10px;
}
.masterCode-sel-cls ::v-deep .el-input .el-input__inner {
    height: 30px;
}
.masterCode-sel-cls ::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.masterCode-sel-cls ::v-deep .el-tag__close.el-icon-close {
    top: -6px;
}

.input-with-select {
    width: 230px;
    margin-right: 15px;
    margin-bottom: 10px;
    display: inline-block;
}
.input-with-select.date-range {
    width: 330px;
    display: inline-flex;
}
.input-with-select.select2 {
    width: 280px;
}
.select-boolean {
    width: 180px;
}
.template-uploader {
    margin-left: 10px;
    margin-right: 10px;
}

.wl-left .wl-green {
    margin-left: 5px;
}
.table-container-wrapper {
    height: calc(100% - 97px - 55px);
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 117px - 125px);
}
</style>
